import { hydrateQuestionThreads } from '@components/dynamic-form/hydrateQuestionThreads';
import { hydrateQuestionData } from '@src/app-components/dynamic-form/hydrateQuestionData';
import { hydrateSectionData } from '@src/app-components/dynamic-form/hydrateSectionData';
import {
  nprConfigByKey,
  resolveNprConfig,
  type NprConfig,
  type NprVariant,
} from '@src/app-pages/Forms/registry/configs/npr/nprConfig';
import { RequestType } from '@src/utils/enums';

const hydrateNprConfig = (config: NprConfig) => {
  // Generate parent threads for each question
  hydrateQuestionThreads({ questionsById: config.questionsById, getParentObject: config.getParentObject });
  // Add question ids and names to each question and question lists - reduces duplicate config
  hydrateQuestionData({ questionsById: config.questionsById, questionNamesById: config.nprQuestionNameById });
  // Add section ids for each section - reduces duplicate config definitions
  hydrateSectionData({ sectionsById: config.sectionsById });
};

Object.values(nprConfigByKey).forEach(hydrateNprConfig);

export const getNprForm = ({ variant, version }: { variant: NprVariant; version: number }) => {
  const activeConfig = resolveNprConfig(variant, version);
  return {
    formId: 1,
    formTitle:
      variant === 'abNpr'
        ? `${RequestType.ActivityBasedNoPermitRequired} Information`
        : `${RequestType.NoPermitRequired} Information`,
    questionsById: activeConfig.questionsById,
    regionHeader: '',
    sections: [activeConfig.sectionsById[1], activeConfig.sectionsById[2]],
    subtitle: '',
    isInformation: false,
  };
};
